import React, { Suspense, useCallback } from 'react';
import { generateReportToken } from '@/services/analytics';
import theme from './SellerReportsPage.module.scss';
import { LazyReport } from '@/components/Reporting/LazyReport';
import { useCurrentCulture } from '@/utils/hooks';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { SimplePageTitle } from '@/components/layout/PageTitle';
import { t } from '@lingui/core/macro';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { useParams } from 'react-router';

type ReportName = 'options' | 'surveys';

interface ReportInfo {
    key: string;
    title(): string;
}

function getReportInfo(reportName: ReportName): ReportInfo {
    switch (reportName) {
        case 'options':
            return { key: 'AdminProducts', title: () => t`Report` };
        case 'surveys':
            return { key: 'Surveys', title: () => t`Survey report` };
    }
}

interface SellerReportsPageParams {
    reportName: ReportName;
}

interface SellerReportsPageProps {}

const SellerReportsPage: React.FC<SellerReportsPageProps> = (props) => {
    const profile = useSelector((state: IState) => state.global.activeProfile);
    const [currentCulture] = useCurrentCulture();
    const { reportName } = useParams<SellerReportsPageParams>();
    const reportInfo = getReportInfo(reportName);

    const loader = useCallback(() => {
        if (!profile) {
            return Promise.resolve(null);
        }

        return generateReportToken(profile.id, reportInfo.key);
    }, [profile?.id, reportInfo.key]);

    if (!profile) {
        return <LoadingIndicator />;
    }

    return (
        <Suspense fallback={<LoadingIndicator />}>
            <div className={theme.container}>
                <SimplePageTitle title={reportInfo.title()} />
                {/* <Report reportType={ReportType.AdminCases} profileId={profile.profileId} /> */}

                <LazyReport loader={loader} locale={currentCulture?.locale} />
            </div>
        </Suspense>
    );
};

export default SellerReportsPage;
